

























































































































































































































































































































































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import Avatar from '@/components/common/Avatar.vue';
import PolicyProductLink from '@/components/common/PolicyProductLink.vue';
import PolicyTagLink from '@/components/common/PolicyTagLink.vue';
import PolicyUserLink from '@/components/common/PolicyUserLink.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { FormatMixin } from '@/mixins/FormatMixin';
import { PermissionMixin } from '@/mixins/PermissionMixin';
import { Util } from '@/utils/Util';
import AntragsbuchColumnSelect from '@/views/pages/policies/AntragsbuchColumnSelect.vue';
import EditPolicyModal from '@/views/pages/policies/EditPolicyModal.vue';
import HorizontalPolicyStatusSelect from '@/views/pages/policies/HorizonalPolicyStatusSelect.vue';
import PoliciesColumnSelect from '@/views/pages/policies/PoliciesColumnSelect.vue';
import PolicyStatusCheckbox from '@/views/pages/policies/PolicyStatusCheckbox.vue';
import { IFile, IPolicy } from 'admiral-core';
import dayjs from 'dayjs';
import _get from 'lodash.get';
import { FileApi } from '@/services/FileApi';
import { mixins } from 'vue-class-component';
import {
  BoxIcon,
  CheckIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  DollarSignIcon,
  Edit2Icon,
  FileIcon,
  HashIcon,
  MoreVerticalIcon,
  PieChartIcon,
  PlusIcon,
  DownloadIcon,
  TrendingUpIcon,
  UserIcon,
  XIcon,
  ArrowRightIcon,
  TrashIcon,
} from 'vue-feather-icons';
import Multiselect from 'vue-multiselect';
import { Component, Prop, Watch } from 'vue-property-decorator';
import 'vue-select/dist/vue-select.css';
import AdmiralCheckbox from '@/components/common/selects/AdmiralCheckbox.vue';
import AssignFileModal from './AssignFileModal.vue';
import { BModal } from 'bootstrap-vue';
export type Order = 'desc' | 'asc';
export type ColumnName = string;
export interface SortValue {
  columnName: ColumnName;
  order: Order;
}

@Component({
  components: {
    AntragsbuchColumnSelect,
    PolicyUserLink,
    PolicyTagLink,
    PolicyProductLink,
    EditPolicyModal,
    PoliciesColumnSelect,
    PlusIcon,

    HorizontalPolicyStatusSelect,
    PolicyStatusCheckbox,
    TrendingUpIcon,
    UserIcon,
    BoxIcon,
    DollarSignIcon,
    HashIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    PieChartIcon,
    MoreVerticalIcon,
    Edit2Icon,
    TrashIcon,
    Avatar,
    Multiselect,
    CheckIcon,
    XIcon,
    FileIcon,
    DownloadIcon,
    AdmiralCheckbox,
    ArrowRightIcon,
    AssignFileModal,
  },
})
export default class FileInboxOverview extends mixins(BaseMixin, FormatMixin, PermissionMixin) {
  @Prop({ required: true, type: Array })
  files!: IFile[];

  @Prop({ type: Boolean, default: () => true })
  search!: boolean;

  // @Prop({ type: Number, default: () => 10 })
  // itemsPerPage!: number;

  @Prop({ type: Boolean, default: () => false })
  isLoading!: boolean;

  @Prop({ type: Boolean, default: () => false })
  embedded!: boolean;

  isContentHovered = false;

  checkAssignedTask = true;
  checkAssignedPolicy = true;
  checkAssignedDamage = true;
  checkUnassigned = true;

  scrolled = false;

  PAGES = 10;

  currentPage = 0;
  pagesExpanded = false;

  searchQuery = '';

  selectedFile?: Partial<IFile> = {};

  sortValue: SortValue = {
    columnName: 'updatedAt',
    order: 'desc',
  };

  get itemsPerPage() {
    return 10;
  }

  async reload() {
    await this.$emit('reload');
  }

  formatFileSize(fileSize: number) {
    return Util.formatFileSize(fileSize);
  }

  pagesCount() {
    return Math.ceil(this.filteredFiles().length / this.itemsPerPage);
  }
  paginationCount() {
    return Math.ceil(this.filteredFiles().length / this.itemsPerPage);
  }

  @Watch('searchQuery')
  watchSearchQuery() {
    if (this.searchQuery.length === 0 || this.searchQuery.length === 1) {
      this.currentPage = 0;
    }
  }

  filteredFiles(): IFile[] {
    const result: IFile[] = this.files;

    const computedResult = result
      .filter((file: IFile) => {
        if (this.searchQuery.length > 2) {
          return JSON.stringify(file).toLowerCase().includes(this.searchQuery.toLowerCase());
        }
        return true;
      })
      .filter((file: IFile) => {
        if (this.checkAssignedTask && file.task) {
          return true;
        }
        if (this.checkAssignedPolicy && file.policy) {
          return true;
        }
        if (this.checkAssignedDamage && file.damage) {
          return true;
        }
        if (this.checkUnassigned && !file.task && !file.policy && !file.damage) {
          return true;
        }
        return false;
      });

    return computedResult;
  }

  formatOnlyDate(date: Date) {
    return Util.formatDate2(date);
  }

  formatDate(date: Date) {
    return Util.formatDate(date);
  }

  formatDateFull(date: Date) {
    return dayjs(date).format('DD.MM.YYYY HH:mm');
  }

  get sortedList() {
    const columnName: keyof IFile = this.sortValue.columnName as keyof IFile;

    const compare = (a: IFile, b: IFile) => {
      const rawA = _get(a, columnName);
      const rawB = _get(b, columnName);

      const normalize = (value: unknown): string | number | null => {
        if (value === null || value === undefined) {
          return null;
        }

        // Date object or date-like string → compare by timestamp
        if (value instanceof Date) {
          return value.getTime();
        }
        if (typeof value === 'string') {
          const parsed = dayjs(value);
          if (parsed.isValid()) {
            return parsed.valueOf();
          }
          return value;
        }

        // Object with id → compare by id
        if (typeof value === 'object') {
          const maybeWithId = value as { id?: string | number };
          if (maybeWithId && maybeWithId.id !== undefined) {
            return maybeWithId.id as string | number;
          }
          return null;
        }

        // number/boolean
        return value as number;
      };

      const aValue = normalize(rawA);
      const bValue = normalize(rawB);

      // Handle nulls consistently (place at end for asc)
      if (aValue === null && bValue === null) return 0;
      if (aValue === null) return this.sortValue.order === 'asc' ? 1 : -1;
      if (bValue === null) return this.sortValue.order === 'asc' ? -1 : 1;

      let result = 0;

      if (typeof aValue === 'string' && typeof bValue === 'string') {
        result = aValue.localeCompare(bValue);
      } else {
        const numA = aValue as number | string;
        const numB = bValue as number | string;
        if (numA < numB) result = -1;
        else if (numA > numB) result = 1;
        else result = 0;
      }

      return this.sortValue.order === 'asc' ? result : -result;
    };
    return this.filteredFiles().sort(compare);
  }

  get getPaginatedItems() {
    return this.sortedList.slice(
      this.currentPage * this.itemsPerPage,
      this.currentPage * this.itemsPerPage + this.itemsPerPage,
    );
  }

  hasSort(columnName: ColumnName, order: Order) {
    return this.sortValue.columnName === columnName && this.sortValue.order === order;
  }

  setSort(columnName: ColumnName, order: Order) {
    this.sortValue = {
      columnName,
      order,
    };
  }

  isNew(policy: IPolicy) {
    return dayjs(policy.createdAt).isSame(dayjs(), 'date');
  }

  async downloadFile(file: IFile) {
    await Util.downloadExistingFile(file);
  }

  async deleteFile(file: IFile) {
    try {
      this.selectedFile = file;
      // confirm first, use delete-file modal
      (this.$refs['modal-delete-file'] as any).show();
      return;
    } catch (e) {
      this.$toastr.e('Beim Löschen der Datei ist etwas schief gelaufen.');
      throw e;
    }
  }

  async confirmDeletion() {
    try {
      if (!this.selectedFile) {
        throw new Error('Datei nicht gefunden');
      }
      await FileApi.deleteFile(this.selectedFile.id!);
      this.$toastr.s('Datei erfolgreich gelöscht.');
      this.$emit('reload');
      (this.$refs['modal-delete-file'] as any).hide();
    } catch (e) {
      this.$toastr.e('Beim Löschen der Datei ist etwas schief gelaufen.');
      throw e;
    }
  }

  async openAssignFileModal(file: IFile) {
    this.selectedFile = file;
    // await this.$router.push({ name: 'policy.update', params: { id: policy.id } }).catch((err) => {
    //   //
    // });

    // eslint-disable-next-line
    (this.$refs['assign-file-modal'] as any).$refs['assign-file'].show();
  }
}
